module.exports = __webpack_public_path__ + "static/media/contractors.54336ed1.svg";